import type { ReactNode } from 'react'

import type { ThemeMode } from '@/hooks/useLightMode'

import { Stack, Text } from '@hivewatch/dark'

import { settingsColorToken } from '../utils/settingsColorToken'

interface SettingsGroupIProps {
  colorScheme: ThemeMode
  title: string
  children: ReactNode
}

/**
 * The shared form-group primitive for rebrand Settings sections: a heading
 * over a 16px-gap stack, capped at the section content width. Promoted from
 * `features/account-information` on its second consumer (ENG-33235).
 */
export const SettingsGroup = ({
  colorScheme,
  title,
  children,
}: SettingsGroupIProps) => (
  <Stack gap='16px' maxW='528px' w='full'>
    <Text
      color={settingsColorToken(colorScheme, 'text.primary')}
      textStyle='heading'
    >
      {title}
    </Text>
    {children}
  </Stack>
)
